export const SESH_changesMaxAge = 2500
export const SESH_syncMonitorInterval = 500
